import { loginStore } from "@/modules/login/store";
import { themeStore } from "@/stores/theme";
import { isZh } from "@/utils/lang";
import { Box, Center, Portal } from "@chakra-ui/react";
import { langStore } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { accelerationStore } from "@/stores/acceleration";
import { wenxinStore } from "@/thirdParty/wenxin/store";
import { useChannelTrace, useTDK } from "@/utils/tool";
import { RouteComponentProps } from "react-router";
import { getLang, RouterSwitch } from "@/router/hook";
import { useCheckAlbum } from "@/pages/Gallery/hooks";
import events, { MessageType } from "@/utils/events";
import { userAssetsStore } from "@/stores/userAssets";

function Global() {
  const { boardBg } = themeStore.styles;
  const {
    userState: { userInfo },
  } = loginStore;
  useEffect(() => {
    const tgt = getLang();
    langStore.switchTo(tgt);
  }, [localStorage.lang]);

  useLayoutEffect(() => {
    const loadingEl = document.querySelector(".noli-loading");
    if (loadingEl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      loadingEl.style.display = "none";
    }
  }, []);

  useEffect(() => {
    const {
      userState: { userInfo },
    } = loginStore;
    // if (userInfo && userInfo?.userId) {
    //   ahamoment.identify(String(userInfo.userId));
    // }
  }, [loginStore.userState.userInfo.userId]);

  useEffect(() => {
    loginStore.setGlobalLoading(true);
    if (loginStore.isLogin && !loginStore.hasUserInfo) {
      loginStore
        .getUserInfo()
        .then(() => {
          loginStore.setGlobalLoading(false);
        })
        .catch(() => {
          const path = location.pathname;
          if (path && !["/", "/login", "/business"].includes(path)) {
            location.replace("/login");
          }
          loginStore.setGlobalLoading(false);
        });
    } else {
      loginStore.setGlobalLoading(false);
    }
  }, []);
  useCheckAlbum();
  useTDK();
  useChannelTrace();

  useEffect(() => {
    if (userInfo?.userId) {
      accelerationStore.fetchAccelerateData();
      wenxinStore.fetchWenxinStatus();
    } else {
      accelerationStore.reset();
      wenxinStore.reset();
    }
  }, [userInfo?.userId]);

  function openHeartCoinModal() {
    userAssetsStore.setHeartCoinPayModalOpen(true);
  }

  useEffect(() => {
    events.on(MessageType.HEART_COIN, openHeartCoinModal);
    return () => {
      events.off(MessageType.HEART_COIN, openHeartCoinModal);
    };
  }, []);

  return (
    <>
      {loginStore.globalLoading && !loginStore.isGuest ? (
        <Portal>
          <Center
            position="fixed"
            zIndex={9999999}
            left={0}
            top={0}
            minW="1440px"
            w="100vw"
            h="100vh"
            bg={boardBg}
          >
            {/* <NoliLoading w="180px" h="auto" /> */}
          </Center>
        </Portal>
      ) : (
        <BrowserRouter>
          <Route
            path="/en"
            render={(props: RouteComponentProps) => {
              return RouterSwitch(props);
            }}
          />
          <Route
            path="/"
            render={(props: RouteComponentProps) => {
              return RouterSwitch(props);
            }}
          />
        </BrowserRouter>
      )}
    </>
  );
}
export default observer(Global);
